import * as Bixby from './../../core';

export interface CloDealBixbyIdMappingState {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  cloDealBixbyIdMappings?: Bixby.Models.CloDealBixbyIdMapping[];
}

export const ALL_CLO_DEAL_BIXBYID_MAPPING_SUCCESS = "ALL_CLO_DEAL_BIXBYID_MAPPING_SUCCESS";
export const ALL_CLO_DEAL_BIXBYID_MAPPING_FAILURE = 'ALL_CLO_DEAL_BIXBYID_MAPPING_FAILURE';
export const ALL_CLO_DEAL_BIXBYID_MAPPING_LOADING = "ALL_CLO_DEAL_BIXBYID_MAPPING_LOADING";

export const ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_SUCCESS = "ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_SUCCESS";
export const ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_FAILURE = 'ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_FAILURE';
export const ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_LOADING = "ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_LOADING";

interface AllCloDealBixbyIdMappingLoading extends Bixby.Models.BixbyAction<undefined, typeof ALL_CLO_DEAL_BIXBYID_MAPPING_LOADING> {
  type: typeof ALL_CLO_DEAL_BIXBYID_MAPPING_LOADING;
}

interface AllCloDealBixbyIdMappingSuccess extends Bixby.Models.BixbyAction<Bixby.Models.CloDealBixbyIdMapping[], typeof ALL_CLO_DEAL_BIXBYID_MAPPING_SUCCESS> {
  type: typeof ALL_CLO_DEAL_BIXBYID_MAPPING_SUCCESS;
}

interface AllCloDealBixbyIdMappingFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof ALL_CLO_DEAL_BIXBYID_MAPPING_FAILURE> {
  type: typeof ALL_CLO_DEAL_BIXBYID_MAPPING_FAILURE;
}

interface AllCloDealBixbyIdMappingUpdateLoading extends Bixby.Models.BixbyAction<undefined, typeof ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_SUCCESS> {
  type: typeof ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_SUCCESS;
}

interface AllCloDealBixbyIdMappingUpdateSuccess extends Bixby.Models.BixbyAction<Bixby.Models.CloDealBixbyIdMapping[], typeof ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_FAILURE> {
  type: typeof ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_FAILURE;
}

interface AllCloDealBixbyIdMappingUpdateFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_LOADING> {
  type: typeof ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_LOADING;
}

export type CloDealActionTypes =
  | AllCloDealBixbyIdMappingLoading
  | AllCloDealBixbyIdMappingSuccess
  | AllCloDealBixbyIdMappingFailure
  | AllCloDealBixbyIdMappingUpdateLoading
  | AllCloDealBixbyIdMappingUpdateSuccess
  | AllCloDealBixbyIdMappingUpdateFailure;